module.exports = __webpack_public_path__ + "img/banner_index.8bcd786e.png";